(function() {
	var ENTITY_TYPES = {
		SWB: "SWB",
		GWB: "GWB",
		MED: "MED",
		RBD: "RBD",
		SPA: "SPA",
		GPA: "GPA",
		MST: "MST",
		MST_GW: "MST_GW",
		AGG: "AGG",
		DIS: "DIS",
		TRE: "TRE",
		NVZ: "NVZ"
	};

	var GIS_IDS_KEY = "gis.ids";

	var OPEN_GIS_EVENT = "GIS_REQUIRED";

	angular.module("pphhApp")
		.factory("GisService", ["$rootScope", "$http", "$q", "SessionStorageService", GisServiceFactory]);

	/**
	 * Factoría que instancia el servicio que permite interactuar con el visor geográfico.
	 */
	function GisServiceFactory($rootScope, $http, $q, sessionStorageService) {

		var serviceInstance = {
			getDmaWaterbody: getDmaWaterbody,
			getNidMonitoringSite: getNidMonitoringSite,
			getSelection: getSelection,
			openViewer: openViewer,
			openViewerMultiple:openViewerMultiple,
			openEmptyViewer: openEmptyViewer,
			openSurfaceWaterBodyViewer: openSurfaceWaterBodyViewer,
			openGroundWaterBodyViewer: openGroundWaterBodyViewer,
			openMeasureViewer: openMeasureViewer,
			openRbdViewer: openRbdViewer,
			openSurfaceProtectedAreaViewer: openSurfaceProtectedAreaViewer,
			openGroundProtectedAreaViewer: openGroundProtectedAreaViewer,
			openMonitoringSiteViewer: openMonitoringSiteViewer,
			openAgglomerationViewer: openAgglomerationViewer,
			openTreatmentPlanViewer: openTreatmentPlanViewer,
			openDischargePointViewer: openDischargePointViewer,
			openNitratesViewer: openNitratesViewer,
			deleteElement: deleteElement,
			deleteGroup: deleteGroup,
			clearGroup: clearGroup,
			clear: clear,
			refreshMap: refreshMap,
			findGroupByEntityType: findGroupByEntityType,
			getSavedIds:getSavedIds
		};

		return serviceInstance;

		function openSurfaceWaterBodyViewer(id) {
			openViewer(ENTITY_TYPES.SWB, id);
		}

		function openGroundWaterBodyViewer(id) {
			openViewer(ENTITY_TYPES.GWB, id);
		}

		function openMeasureViewer(id) {
			openViewer(ENTITY_TYPES.MED, id);
		}

		function openRbdViewer(id) {
			openViewer(ENTITY_TYPES.RBD, id);
		}

		function openSurfaceProtectedAreaViewer(id) {
			openViewer(ENTITY_TYPES.SPA, id);
		}

		function openGroundProtectedAreaViewer(id) {
			openViewer(ENTITY_TYPES.GPA, id);
		}

		function openMonitoringSiteViewer(id) {
			openViewer(ENTITY_TYPES.MST, id);
		}

		function openAgglomerationViewer(id) {
			openViewer(ENTITY_TYPES.AGG, id);
		}

		function openTreatmentPlanViewer(id) {
			openViewer(ENTITY_TYPES.TRE, id);
		}

		function openDischargePointViewer(id) {
			openViewer(ENTITY_TYPES.DIS, id);
		}
		
		function openNitratesViewer(id) {
			openViewer(ENTITY_TYPES.NVZ, id);
		}

		/**
		 * Devuelve los datos almacenados con el histórico de la selección del usuario.
		 */
		function getSelection() {
			var savedIds = getSavedIds();
			return getData(savedIds);
		}

		/**
		 * Incluye un determinado elemento a visualizar en el visor geográfico.
		 */
		function openViewer ( entityType, id ){
			return openViewerMultiple ( entityType, id, false);
		}
		/**
		 * 7698 se añade funcion especifica para la seleccion multiple
		 */
		function openViewerMultiple ( entityType, id, multiple){
			var eventType;

			var savedIds = getSavedIds();

			if ( Array.isArray(id) ){
				eventType = "reloadElements";
				// 7698 solo se borrara el grupo si la seleccion es multiple
				if ( multiple === true){
					var groupFound = findGroupByEntityType(savedIds, entityType);				
					if (groupFound != null ){
						clearGroup(groupFound, savedIds);
						savedIds = getSavedIds();
					}
				}
				
				setIds( savedIds, entityType, id );
			}
			else{
				eventType = "elementAdded";
				addId(savedIds, entityType, id);
			}

			return getData(savedIds).then(function(selectionInfo) {
				var payload = {
					selectionInfo: selectionInfo,
					addedElement: {
						entityType: entityType,
						id: id
					}
				};

				$rootScope.$broadcast(OPEN_GIS_EVENT, {
					type: eventType,
					payload: payload
				});
			});
		}

		function getSavedIds() {
			var savedIds = sessionStorageService.getObj(GIS_IDS_KEY);
			if (savedIds == null) {
				return [];
			} else {
				return savedIds;
			}
		}

		function addId(savedIds, entityType, id) {
			var groupFound = findGroupByEntityType(savedIds, entityType);

			if (groupFound == null) {
				groupFound = {
					entityType: entityType,
					ids: []
				};
				savedIds.push(groupFound);
			}

			if (groupFound.ids.indexOf(id) < 0) {
				groupFound.ids.push(id);
			}

			sessionStorageService.saveObj(GIS_IDS_KEY, savedIds);
		}
		function setIds (savedIds, entityType, allIds) {
			var groupFound = findGroupByEntityType(savedIds, entityType);

			if (groupFound == null) {
				groupFound = {
					entityType: entityType,
					ids: []
				};
				savedIds.push(groupFound);
			}
			// 7698 comprobamos si existen los ids y los vamos añadiendo
			// 7698 comprobamos si existen los ids y los vamos añadiendo
			var index = 0;
			for ( index = 0; index < allIds.length; index ++){
				let id = allIds[index];
				if (groupFound.ids.indexOf(id) < 0) {
						groupFound.ids.push(id);
					}
			}			

			sessionStorageService.saveObj(GIS_IDS_KEY, savedIds);
		}
		function findGroupByEntityType(savedIds, entityType) {
			var groupFound = null;
			angular.forEach(savedIds, function(group) {
				if (group.entityType === entityType) {
					groupFound = group;
				}
			});

			return groupFound;
		}

		function getData(savedIds) {
			var deferrer = $q.defer();

			$http({
				method: "POST",
				url: "/gis/selection-info",
				data: {
					groups: savedIds
				}
			}).then(function(response) {
				var groups = response.data;
				deferrer.resolve(groups);
			}, function() {
				deferrer.reject();
			});

			return deferrer.promise;
		}

		function deleteElement(entityType, elementId) {
			var selections = getSavedIds();
			var group = findGroupByEntityType(selections, entityType);

			var elementIndex = group.ids.indexOf(elementId);
			if (elementIndex < 0) {
				return;
			}
			group.ids.splice(elementIndex, 1);

			if (group.ids.length === 0) {
				selections.splice(selections.indexOf(group), 1);
			}

			sessionStorageService.saveObj(GIS_IDS_KEY, selections);

			getData(selections).then(function(selectionInfo) {
				var payload = {
					selectionInfo: selectionInfo,
					removedElement: {
						entityType: entityType,
						id: elementId
					}
				};

				$rootScope.$broadcast(OPEN_GIS_EVENT, {
					type: "elementRemoved",
					payload: payload
				});	
				//17507 Añadido para el refresco al borrar elementos			
				// Si no hay elementos se cambia de categoria o se oculta el mapa.
				if ( group.ids.length < 1 ){
					if ( selections.length < 1 ){
						// ocultamos el mapa
						$rootScope.$broadcast(OPEN_GIS_EVENT, {
							type:  "hideMap"							
						});						
						return;
					}
				}

				
								
			});
			
	
		}
		//17507 Añadido para el refresco al borrar elementos
		function refreshMap ( ){
			getSelection().then(function(selectionInfo) {			
				// Recargamos los elementos existentes
				var payload = {
					selectionInfo: selectionInfo
				};

				$rootScope.$broadcast(OPEN_GIS_EVENT, {
					type:  "reloadElements",
					payload: payload
				});
			});
		}

		function clearGroup (group, savedIds){
			group.ids.splice(0, group.ids.length);
			savedIds.splice(savedIds.indexOf(group), 1);
			clear();
		}

		function deleteGroup (group ){
			var selections = getSavedIds();
			var entityType = group.entityType;

			var parentGroup = findGroupByEntityType(selections, entityType);
			//17507 Añadido para el refresco al borrar elementos
			var ids = [];
			
			angular.forEach(group.elements, function(element) {
				var elementIndex = parentGroup.ids.indexOf(element.id);
				if (elementIndex < 0) {
					return;
				}
				ids.push(parentGroup.ids[elementIndex] );
				parentGroup.ids.splice(elementIndex, 1);
			});

			if (parentGroup.ids.length === 0) {
				selections.splice(selections.indexOf(parentGroup), 1);
			}

			sessionStorageService.saveObj(GIS_IDS_KEY, selections);

			getData(selections).then(function(selectionInfo) {
				var payload = {
					selectionInfo: selectionInfo,
					removedElement: {
						entityType: entityType,
						id: ids
					}
				};

				$rootScope.$broadcast(OPEN_GIS_EVENT, {
					type: "elementRemoved",
					payload: payload
				});
				//17507 Añadido para el refresco al borrar elementos
				// Si no hay elementos se cambia de categoria o se oculta el mapa.
				if ( selections.length < 1 ){
					// ocultamos el mapa
					$rootScope.$broadcast(OPEN_GIS_EVENT, {
						type:  "hideMap"							
					});						
					return;
				}
			});
		}

		function clear() {
			sessionStorageService.remove(GIS_IDS_KEY);
		}

		/**
		 * Informa que se requiere abrir el visor para poder localizar
		 * ciertos elementos bajo una configuración determinada.
		 */
		function openEmptyViewer(entityType, versionId) {
			getMessage(entityType, versionId).then(function(message) {
				$rootScope.$broadcast(OPEN_GIS_EVENT, {
					type: "openEmpty",
					payload: message
				});
			});
		}

		function getMessage(entityType, versionId) {
			var deferrer = $q.defer();

			$http({
				method: "GET",
				url: "/gis/message/" + entityType,
				params: {
					versionId: versionId
				}
			}).then(function(response) {
				deferrer.resolve(response.data);
			}, function() {
				deferrer.reject();
			});

			return deferrer.promise;
		}

		function getDmaWaterbody(id) {
			var deferrer = $q.defer();

			$http({
				method: "POST",
				url: "/gis/getDmaWaterBody",
				params: {
					waterId: id
				}
			}).then(function(response) {
				deferrer.resolve(response.data);
			}, function() {
				deferrer.reject();
			});

			return deferrer.promise;
		}
		
		function getNidMonitoringSite ( euCd, versionId ){
			var deferrer = $q.defer();
			$http({
				method: "POST",
				url: "/gis/getNidMonitoringSite",
				params: {
					euCd: euCd,
					versionId: versionId
				}
			}).then(function(response) {
				deferrer.resolve(response.data);
			}, function() {
				deferrer.reject();
			});

			return deferrer.promise;
		}
	}

})();